import React, { memo } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { Lock } from '@material-ui/icons';
import { MoreVertIconContrast } from '../../../icons/MoreVertIconContrast';
import { IconButton } from '../../material-ui/IconButton';
import { ListItem, ListItemSecondaryAction, ListItemText } from '../../material-ui/List';
import { Menu, MenuItem } from '../../material-ui/Menu';
import { useAirportServiceListItem } from './useAirportServiceListItem';
import { getTranslateText } from '../../../service/utils';
import { useStyles } from './useStyles';

export const AirportServiceListItem = memo(({ legId, service, allowEdit, allowDelete }) => {
    const { id, dateBegin, dateEnd, dateBeginReal, dateEndReal, comment, lock, isRemoved, isEdited } = service;

    const isDisabled = isRemoved || !allowEdit || lock;

    const classes = useStyles();
    const className = isRemoved ? classes.listItemRemoved : isEdited ? classes.listItemEdited : null;

    const {
        handleClick,
        handleStartClick,
        handleSingleClick,
        handleEndClick,
        handleCancelClick,
        handleDelete,
        handleCancelDelete,
        anchorEl,
        handleOpenMenu,
        handleClose,
    } = useAirportServiceListItem(legId, service);

    const { t: translate } = useTranslation();

    return (
        <>
            <ListItem id={id} disabled={isDisabled} button={true} className={className} onClick={handleClick}>
                <ListItemText
                    primary={
                        <span className={classes.serviceWrapper}>
                            <span className={classes.service}>{getTranslateText('name', service)}</span>
                            <span className={classnames(classes.time, !dateBeginReal ? classes.textDisable : null)}>
                                {(dateBeginReal || dateBegin) && moment.utc(dateBeginReal || dateBegin).format('HH:mm ')}
                            </span>
                            <span className={classnames(classes.time, !dateEndReal ? classes.textDisable : null)}>
                                {(dateEndReal || dateEnd) && moment.utc(dateEndReal || dateEnd).format('HH:mm ')}
                            </span>
                            <span className={classes.lock}>{lock && <Lock width="24" height="24" className={classes.iconLock} />}</span>
                        </span>
                    }
                    secondary={<span>{comment}</span>}
                />
                <ListItemSecondaryAction>
                    <IconButton style={{ padding: '9px' }} onClick={handleOpenMenu}>
                        <MoreVertIconContrast />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
            <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                {!isDisabled && !dateBeginReal && !dateEndReal && (
                    <MenuItem onClick={handleStartClick}>{translate('airportServices.start')}</MenuItem>
                )}
                {!isDisabled && !dateBeginReal && !dateEndReal && (
                    <MenuItem onClick={handleSingleClick}>{translate('airportServices.single')}</MenuItem>
                )}
                {!isDisabled && dateBeginReal && !dateEndReal && (
                    <MenuItem onClick={handleEndClick}>{translate('airportServices.end')}</MenuItem>
                )}
                {!isDisabled && dateBeginReal && <MenuItem onClick={handleCancelClick}>{translate('cancel')}</MenuItem>}
                {!isRemoved && !lock && allowDelete && (
                    <MenuItem onClick={handleDelete}>{translate('airportServices.deleteOperation')}</MenuItem>
                )}
                {isRemoved && <MenuItem onClick={handleCancelDelete}>{translate('airportServices.cancelDeletion')}</MenuItem>}
            </Menu>
        </>
    );
});
